import React from 'react';
import subnavbarData from '../../fakeData/subnavbarData';
import subnavbarDataForRoute from '../../fakeData/subnavbarDataForRoute';
import './SubNavbar.css';
import { Link } from 'react-router-dom';
const SubNavbar = () => {
    const { location: { pathname } } = window;
    return (
        <ul className="nav justify-content-center">
            {
                pathname !== '/' ? subnavbarDataForRoute.map((item, index) => (
                    <li className="nav-item" key={index}>

                        {

                            <Link className="nav-link active subnavbar-content" to={item.to}>{item.content}</Link>
                        }

                    </li>
                )) :
                    subnavbarData.map((item, index) => (
                        <li className="nav-item" key={index}>

                            {
                                <a className='nav-link active subnavbar-content' href={item.to}>{item.content}</a>
                            }

                        </li>
                    ))
            }
        </ul>
    );
};

export default SubNavbar;